import { Table } from "@fluentui/react-northstar";
import React, { PureComponent } from "react";
import StatsService from "../../apiservices/StatsService";
import { Loader } from "@fluentui/react-northstar";

const header = {
  items: ["Name", "Atendidas", "Fallidas", "Tiempo medio al habla"],
};
const rowsPlain = [
  {
    key: 1,
    items: ["Cristina Villalobos", 56, 3],
  },
  {
    key: 2,
    items: ["Elena Fernández", 54, 2],
  },
  {
    key: 3,
    items: ["Dante Di Diego", 40, 6],
  },
  {
    key: 4,
    items: ["Tamara Fernandez", 13, 44],
  },
  {
    key: 5,
    items: ["Juan Reyna", 40, 2],
  },
];

export default class CallsByAgent extends PureComponent {
  state = {
    activeIndex: 0,
    data: [],
    isLoading: true,
  };

  changeState = () => {
    const array = this.state.data;
    console.log(array);
    let newArray = [];
    for (let object of array) {
      newArray.push({
        key: object.name,
        items: [
          `${object.name}`,
          `${object.atendidas}`,
          `${object.noAtendidas}`,
          `${object.timeCall}`,
        ],
      });
    }

    this.setState({
      data: newArray,
    });
  };
  componentDidMount() {
    const username = sessionStorage.getItem("userName");
    const tokenString = sessionStorage.getItem("tokenStats");
    const company = sessionStorage.getItem("company");
    for (let queue of this.props.queue) {
      StatsService.getAttendedByAgent(
        this.props.initDate,
        this.props.endDate,
        tokenString,
        username,
        company,
        queue
      ).then((res) => {
        for (let obj of res.data) {
          this.setState((prevState) => ({
            data: [
              ...prevState.data,
              {
                key: obj.name,
                items: [
                  `${obj.name}`,
                  `${obj.atendidas}`,
                  `${obj.noAtendidas}`,
                  `${obj.timeCall}`,
                ],
              },
            ],
          }));
        }
        this.setState({
          isLoading: false,
        });
      });
    }
  }

  render() {
    return (
      <>
        {this.state.isLoading ? (
          <Loader
            styles={{
              marginTop: "20%",
            }}
          />
        ) : (
          <Table
            filterable={true}
            compact
            header={header}
            rows={this.state.data}
            aria-label="Compact view static table"
          />
        )}
      </>
    );
  }
}
